import { render, staticRenderFns } from "./LoginForms.vue?vue&type=template&id=07b39c99&scoped=true&"
import script from "./LoginForms.vue?vue&type=script&lang=js&"
export * from "./LoginForms.vue?vue&type=script&lang=js&"
import style0 from "./LoginForms.vue?vue&type=style&index=0&id=07b39c99&lang=scss&scoped=true&"
import style1 from "./LoginForms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b39c99",
  null
  
)

export default component.exports